'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dPage$0024 from "./presto.-Freemium2-F-A-Add-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002469 from "./presto.-Presto-Router$$anon$69.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$68() {
  this.bl4 = null;
  this.bkW = null;
  this.bkX = false;
  this.bl5 = null;
  this.bl6 = false;
  this.bl9 = null;
  this.bl2 = null;
  this.bl3 = false;
  this.bkY = null;
  this.bkZ = false;
  this.bl0 = null;
  this.bl1 = false;
  this.bl7 = false;
  this.bl8 = false;
  this.bl4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bl9 = "Freemium2FAAddPage";
}
export { $c_Lpresto_PrestoRouter$$anon$68 as $c_Lpresto_PrestoRouter$$anon$68 };
$p = $c_Lpresto_PrestoRouter$$anon$68.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$68;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$68() {
}
export { $h_Lpresto_PrestoRouter$$anon$68 as $h_Lpresto_PrestoRouter$$anon$68 };
$h_Lpresto_PrestoRouter$$anon$68.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bl4;
});
$p.M = (function() {
  if ((!this.bkX)) {
    this.bkW = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bkX = true;
  }
  return this.bkW;
});
$p.O = (function() {
  if ((!this.bl6)) {
    this.bl5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bl6 = true;
  }
  return this.bl5;
});
$p.E = (function() {
  return this.bl9;
});
$p.t = (function() {
  if ((!this.bl3)) {
    this.bl2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bl3 = true;
  }
  return this.bl2;
});
$p.N = (function() {
  if ((!this.bkZ)) {
    this.bkY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bkZ = true;
  }
  return this.bkY;
});
$p.Q = (function() {
  if ((!this.bl1)) {
    this.bl0 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002469.$c_Lpresto_PrestoRouter$$anon$69();
    this.bl1 = true;
  }
  return this.bl0;
});
$p.v = (function() {
  if ((!this.bl8)) {
    this.bl7 = false;
    this.bl8 = true;
  }
  return this.bl7;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee487) => ((p) => \u03b4scrutinee487))($j_presto$002e$002dFreemium2$002dF$002dA$002dAdd$002dPage$0024.$m_Lpresto_Freemium2FAAddPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$68 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$68, "presto.PrestoRouter$$anon$68", ({
  OK: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$68 as $d_Lpresto_PrestoRouter$$anon$68 };
//# sourceMappingURL=presto.-Presto-Router$$anon$68.js.map
